const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 17.427,
    viewBox: "0 0 19.453 17.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5089",
    d: "M218.218 174.066h-4.179v-9.228a1.292 1.292 0 0 1 1.421-1.385h1.34a1.243 1.243 0 0 1 1.421 1.385z",
    transform: "translate(-206.402 -158.902)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5098",
    d: "M218.218 174.066h-4.179V167.1a1.292 1.292 0 0 1 1.421-1.385h1.34a1.243 1.243 0 0 1 1.421 1.385z",
    transform: "translate(-200.402 -158.902)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5099",
    d: "M218.218 174.066h-4.179V167.1a1.292 1.292 0 0 1 1.421-1.385h1.34a1.243 1.243 0 0 1 1.421 1.385z",
    transform: "translate(-212.402 -158.902)",
    style: {
      fill: "#d9d9d9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5091",
    d: "M18.882 424.064H.571a.571.571 0 1 1 0-1.142h18.311a.571.571 0 1 1 0 1.142z",
    transform: "translate(0 -406.638)",
    style: {
      fill: "#d9d9d9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5092",
    d: "M30.622 60.152a.572.572 0 0 0-.439-.606l-1.845-.446a.571.571 0 0 0-.27 1.11l.522.127-1.48.913-5.61-3.197a.571.571 0 0 0-.525-.021l-5.549 3.209-2.693-2.255a.571.571 0 1 0-.6.969l2.956 2.419a.571.571 0 0 0 .545.033l5.563-3.215 5.647 3.215a.59.59 0 0 0 .583-.01l1.794-1.107-.119.559a.571.571 0 0 0 1.117.239l.4-1.854a.664.664 0 0 0 .003-.082z",
    transform: "translate(-11.49 -57.979)",
    style: {
      fill: "#d9d9d9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.558c38094431ddf80c125b5b7dce3b00.svg";
export { ForwardRef as ReactComponent };